/**
 * Returns a list of strings which represent validation errors
 * @param {string} password the password value to validate
 * @param {object} rules the rules for the validation
 */
export function getPasswordValidationErrors(password, rules) {
  var validationErrors = [];

  const pw = `${password}`;
  const minLength = !!rules && !!rules.minimumLength ? rules.minimumLength : 8;
  const oneLetterOneNumber = !!rules && !!rules.oneLetterOneNumber ? rules.oneLetterOneNumber : true;
  const oneUpperOneLower = !!rules && !!rules.oneUpperOneLower ? rules.oneUpperOneLower : false;
  const oneSpecialChar = !!rules && !!rules.oneSpecialChar ? rules.oneSpecialChar : false;

  if ( pw.length < minLength ) {
    validationErrors.push(`must have at least ${minLength} characters`);
  }
  if (oneLetterOneNumber){
    if ( !(pw.match(/[a-z]/) || pw.match(/[A-Z]/)) || !pw.match(/\d/)) {
      validationErrors.push(`must have at least one letter and one number`);
    }
  }
  if (oneUpperOneLower){
    if (!pw.match(/[a-z]/) || !pw.match(/[A-Z]/)) {
      validationErrors.push(`must have one uppercase letter and one lowercase letter`);
    }
  }
  if (oneSpecialChar){
    // eslint-disable-next-line
    const specialRegex = /[ \-!\$%\^&\*\#@\(\)\?_\+\|~\=`\{}\[\\\:\"\;\'\<\>,\.\/]/;
    if (!pw.match(specialRegex)) {
      validationErrors.push(`must have one special character ( !"#$%&'()*+,-./:;<=>?@[\\]^_\`{|}~)`);
    }
  }
  return validationErrors;
}

/**
 * Runs validation on a form that handles creating a password.
 * @param {object} formState form state, that contains answer values
 * @param {string} passwordId element id of the new password element
 * @param {string} passwordConfirmationId element id of the password confirmation element
 * @param {object} rules password rules
 */
export function validatePasswordChange(formState, passwordId, passwordConfirmationId, rules) {

 var validationErrors = [];

 var newPasswordElement = formState.form.elements.find(val => val.id === passwordId);
 const password = formState.value.get(passwordId);

 var confirmPasswordElement = formState.form.elements.find(val => val.id === passwordConfirmationId);
 const passwordConfirmation = formState.value.get(passwordConfirmationId);

 const passwordRequirementErrors = getPasswordValidationErrors(password, rules);
 validationErrors = validationErrors.concat(passwordRequirementErrors.map((val, index) => ({
   id: `password-${index}`,
   sourceId: passwordId,
   type: 'inline-error',
   context: newPasswordElement.label,
   errorMessage: val,
 })));

 const passwordsMatch = !password || !passwordConfirmation || password === passwordConfirmation;
 if(!passwordsMatch) {
   validationErrors.push({
     id: `password-confirmation-0`,
     sourceId: passwordConfirmationId,
     type: 'inline-error',
     context: confirmPasswordElement.label,
     errorMessage: "The passwords do not match",
   })
 }

 return validationErrors;
}



// WEBPACK FOOTER //
// src/common/password-utilities.js